export default async function getDiagnosticsQuantity() {
  // Permite conocer la cantidad de diagnósticos

  const url =
    localStorage.getItem("endpoint") +
    "diagnosticsquantity/" +
    localStorage.getItem("id");

  try {
    const config = {
      method: "GET",
      headers: {},
    };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
    return { payload: {} };
  }
}
